import { Breadcrumbs as HUIBreadcrumbs, Col, Container, Row } from 'hui';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const BreadcrumbsWrapper = styled.div`
  background-color: #ffffff;
  margin-bottom: 0px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    margin-bottom: 30px;
  }
  border-bottom: 1px solid #d8d8d8;
`;
const BreadcrumbsContainer = styled(Row)`
  max-width: 900px;
`;

const Breadcrumbs = ({ breadcrumbs }) => (
  <BreadcrumbsWrapper>
    <Container p={{ xs: 0, md: '0 1rem' }}>
      <BreadcrumbsContainer>
        <Col xs={0} md={12}>
          <HUIBreadcrumbs breadcrumbs={breadcrumbs} noSchema={true} />
        </Col>
      </BreadcrumbsContainer>
    </Container>
  </BreadcrumbsWrapper>
);

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array
};

export default Breadcrumbs;
